import React from 'react';
import { type BaseNavItem } from '@cx-web/api-clients/nav-api/types';
import classnames from 'classnames';

import ArrowToggle from '../ArrowToggle';
import WrappedIcon from '../WrappedIcon';

import styles from './Accordion.module.css';

interface AccordionProps {
  headerIcon: string;
  headerLink: string;
  headerName: string;
  isActiveAccordion: boolean;
  setActiveAccordion: (sportName: string) => void;
  subLinks: BaseNavItem[];
}

export const Accordion = ({
  headerIcon,
  headerLink,
  headerName,
  isActiveAccordion,
  setActiveAccordion,
  subLinks,
}: AccordionProps) => {
  if (!subLinks || subLinks.length === 0) {
    return null;
  }

  const toggleAccordion = (): void => {
    if (isActiveAccordion) {
      setActiveAccordion('');
    } else {
      setActiveAccordion(headerName);
    }
  };

  return (
    <div className={classnames(styles.accordion)} data-testid="all-sports-accordion">
      <button
        aria-controls={`accordion-header-${headerName}`}
        aria-expanded={isActiveAccordion}
        className={classnames(styles.headerWrapper, isActiveAccordion ? styles.expandedHighlight : '')}
        data-testid="toggle-accordion-button"
        onClick={toggleAccordion}
      >
        <span className={styles.header}>
          <a className={styles.accordionHeader} href={headerLink}>
            <WrappedIcon dimensionString="24" iconString={headerIcon} /> {headerName}
          </a>
        </span>
        <ArrowToggle isOpen={isActiveAccordion} />
      </button>

      <div
        className={classnames(styles.bodyWrapper, isActiveAccordion ? styles.open : '')}
        data-testid="accordion-body-wrapper"
      >
        <div className={styles.accordionBody} data-testid="sub-categories">
          {subLinks.map((item, index) => (
            <a className={styles.category} href={item.link} key={index}>
              {item.name}
            </a>
          ))}
        </div>
      </div>
    </div>
  );
};
